<div class="container">
  <div class='row' >
    <div class = "col-11 col-sm-11" style = "margin: auto; margin-top: 11%; text-align: left;">
      <h1 class="doneLabel" style = "font-weight: bold;font-family: Lato, 'Alegreya Sans'; color: white; font-size: 40px;">{{labels.lblYouPassed}}</h1>
      <h3 style = "font-family: Lato, 'Alegreya Sans'; color: white; opacity: 0.5; font-weight: normal; margin-top: 7%; font-size: 21px;">
        {{labels.lblThankYouforFilling}}. <br>
        {{training.name}}
        <!-- {{labels.lblKlikomNaDugme}}. -->
      </h3>
      <div class="col-12" style = "margin: auto;">
        <button class="login-button" (click)="goToHomePage()">
          <div class = "col-12" style = "margin: auto; text-align: center;">
            <h3 class = "loginBtnLabel">{{labels.lblGoToNextTraining}}</h3>
          </div>
        </button>
      </div>
    </div>
  </div>
</div>
